import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-purchase-confirm",
  templateUrl: "./purchase-confirm.component.html",
  styles: [],
})
export class PurchaseConfirmComponent implements OnInit {
  @Input() content: any;
  loader = false;
  totalTax = 0;
  subTotal = 0;
  total = 0;
  items : any = [];
  names :any = '';
  currency_symbol= '';
  constructor(public dialogRef: NgbActiveModal) {}

  ngOnInit(): void {
    this.items = this.content.items;
    if(this.items && this.items.length > 0){
      this.names = this.items.map((obj)=> obj['name']).join(", ");
    this.totalTax = this.items.map((obj)=> obj['taxPrice']).reduce((a,c) => a* 1 + c*1);
    this.subTotal = this.items.map((obj)=> obj['subTotal']).reduce((a,c) => a* 1 + c*1);
    this.total = this.items.map((obj)=> obj['totalPrice']).reduce((a,c) => a* 1 + c*1);
    this.currency_symbol = this.items[0]['currency_symbol'];
    }
  }
  close() {
    this.dialogRef.close({ success: false });
  }
  onSubmit() {
    this.dialogRef.close({ success: true });
  }
}
